import { QuoteState } from './quote.reducers';
import {EnumQuoteServiceSalesType} from '../../models/enum/enum-quote-service-sales-type';
import {ServiceLine} from '../../models/quote/service-line';


export const getCurrentQuote = (state: QuoteState) => {
  if (state.wrapper) {
    // let data = deserialize(QuoteWrapper, state.wrapper);
    return state.wrapper;
  }
};

export const getClientInfos = (state: QuoteState) => {
  if (state.wrapper) {
    return state.wrapper?.clientInfos;
  }
};

export const getServiceLineByCode = (state: QuoteState, codeService:string): ServiceLine => {
  if (state.wrapper) {
    return state.wrapper.serviceLines.find(quoteService => quoteService.code === codeService);
  }
};

export const getPricingItem = (state: QuoteState, codeService:string, salesType: EnumQuoteServiceSalesType, pricingItemId: string) => {
  if (state.wrapper) {
    const serviceLine = state.wrapper.serviceLines.find(
        (qs) => qs.code === codeService
    );

    if (!serviceLine) return undefined;
    let quoteServiceBySalesType = serviceLine.getQuoteServiceBySalesType(salesType);

    if(!quoteServiceBySalesType) return undefined;

    const customGroup = quoteServiceBySalesType.customGroups.find(
        (cg) => cg.pricingItems.some((pi) => pi.id === pricingItemId)
    );

    if (!customGroup) return undefined;

    return customGroup.pricingItems.find((pi) => pi.id === pricingItemId);
  }
};



export const getReferential = (state: QuoteState) => {
  if (state.referential) {
    return state.referential;
  }
};

export const getReferentialByKey = (state: QuoteState, key: string) => {
  if (state.referential) {
    return state.referential[key];
  }
};

export const getReferentialServices = (state: QuoteState) => {
  if (state.referentialServices && state.referentialServices.length > 0) {
    return state.referentialServices;
  }
};

export const getReferentialServiceByCode = (state: QuoteState, serviceCode:string) => {
  if (state.referentialServices && state.referentialServices.length > 0) {
    return state.referentialServices.find(referentialService => referentialService.serviceCode === serviceCode);
  }
};

export const getReferentialServiceByCodeAndKey = (state: QuoteState, serviceCode:string, key:string) => {
  let referentialService = getReferentialServiceByCode(state,serviceCode);
  if(referentialService) {
    return getReferentialServiceByCode(state,serviceCode)[key];
  }
};

export const getCurrencyQuote = (state: QuoteState) => {
  if (state.wrapper) {
    return state.wrapper.currency;
  }
};

export const getQuoteType= (state: QuoteState) => {
  if (state.wrapper) {
    return state.wrapper.type;
  }
};
